// extracted by mini-css-extract-plugin
export default {"topicView":"TopicView_topicView__RNgyk","title":"TopicView_title__RN98p"};